var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "address-autocomplete", on: { focusout: _vm.onFocusOut } },
    [
      _c(
        "v-text-field",
        _vm._g(
          _vm._b(
            {
              attrs: {
                value: _vm.value,
                autocomplete: _vm.enabled ? "off" : _vm.$attrs.autocomplete,
                role: _vm.enabled ? "combobox" : undefined,
                "aria-expanded": _vm.enabled ? String(_vm.open) : undefined,
                "aria-controls": _vm.enabled ? _vm.listId : undefined,
                "aria-activedescendant":
                  _vm.open && _vm.active >= 0
                    ? _vm.listId + "-" + _vm.active
                    : undefined,
                "aria-autocomplete": "list"
              },
              on: { input: _vm.onInput, keydown: _vm.onKeydown }
            },
            "v-text-field",
            _vm.$attrs,
            false
          ),
          _vm.fieldListeners
        )
      ),
      _vm.open
        ? _c(
            "v-card",
            { staticClass: "address-suggestions", attrs: { elevation: "4" } },
            [
              _c(
                "v-list",
                {
                  staticClass: "py-1",
                  attrs: { id: _vm.listId, role: "listbox", dense: "" }
                },
                _vm._l(_vm.suggestions, function(suggestion, index) {
                  return _c(
                    "v-list-item",
                    {
                      key: suggestion.id,
                      attrs: {
                        id: _vm.listId + "-" + index,
                        role: "option",
                        "aria-selected": String(index === _vm.active),
                        "input-value": index === _vm.active
                      },
                      on: {
                        click: function($event) {
                          return _vm.choose(suggestion)
                        }
                      },
                      nativeOn: {
                        mousedown: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-item-content",
                        { staticClass: "py-1" },
                        [
                          _c(
                            "v-list-item-title",
                            { staticClass: "suggestion-main" },
                            [_vm._v(_vm._s(suggestion.mainText))]
                          ),
                          suggestion.secondaryText
                            ? _c("v-list-item-subtitle", [
                                _vm._v(_vm._s(suggestion.secondaryText))
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              ),
              _c("div", { staticClass: "attribution" }, [_vm._v("Google Maps")])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }